import React from 'react';
import { DEFAULT_MAIN_DATA, MainData, MainDataContext } from './context';

const MainDataProvider: React.FC<React.PropsWithChildren<Record<never, any>>> = ({ children }) => {
  const [mainData, setMainData] = React.useState<MainData>(DEFAULT_MAIN_DATA);

  return <MainDataContext.Provider value={{ mainData, setMainData }}>{children}</MainDataContext.Provider>;
};

export default MainDataProvider;
